import { call, put } from 'redux-saga/effects';

import logger from '@elab/core/utils/logger';

import googleMapsApiLoader from './googleMapsApiLoader';

import { actions } from '.';

export default function* loadGoogleMapsApi(action) {
    try {
        const isLoaded = yield call(googleMapsApiLoader.load, action.payload);
        if (isLoaded) {
            yield put(actions.setGoogleMapsApiLoaded());
        }
    } catch (e) {
        yield call(logger.error, e);
    }
}
